if (!customElements.get('image-with-text-logos')) {
  class ImageWithTextLogos extends HTMLElement {
    #controller = null;

    connectedCallback() {
      this.logos = Array.from(this.querySelectorAll('[data-logo-index]'));
      this.slideshow = this.dataset.slideshow ? document.getElementById(this.dataset.slideshow) : null;

      if (this.logos.length < 2 || !this.slideshow) return;

      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.slideshow.addEventListener('slideChanged', (event) => this.showLogo(event.detail.currentPage - 1), {
        signal,
      });

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
      }

      this.showLogo((this.slideshow.currentPage || 1) - 1);
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }

    showLogo(index) {
      // Keep the current logo when no logo block matches the slide index
      if (!this.logos.some((logo) => Number(logo.dataset.logoIndex) === index)) return;

      this.logos.forEach((logo) => {
        logo.hidden = Number(logo.dataset.logoIndex) !== index;
      });
    }

    onBlockSelect(event) {
      const selectedLogo = this.logos.find((logo) => logo === event.target);
      if (!selectedLogo) return;

      const slide = this.slideshow.sliderItemsToShow?.[Number(selectedLogo.dataset.logoIndex)];
      if (slide) this.slideshow.setSlidePosition(slide.offsetLeft);
    }
  }

  customElements.define('image-with-text-logos', ImageWithTextLogos);
}
